import { render, staticRenderFns } from "./NotFoundPage.vue?vue&type=template&id=6051bc55&scoped=true&"
var script = {}
import style0 from "./NotFoundPage.vue?vue&type=style&index=0&id=6051bc55&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6051bc55",
  null
  
)

export default component.exports